import slice from './slice';

const { reducer } = slice;

export * from './selectors';
export * from './actions';
export { reducer as CoreZonesReducer };